// Platform-aware shortcut labels (#11426, perfection sweep). The palette
// and the strip's doorway badge rendered a hardcoded ⌘ on every platform —
// on Windows/Linux that advertises a key most keyboards don't have while
// the binding that actually works there is Ctrl. The pinned-view digit
// shortcuts are ⌘-only BY DESIGN (Ctrl+1–9 is the browser's own tab
// switching and is not ours to take), so on non-Apple platforms they are
// not advertised at all — a hint for an unusable shortcut is a claim the
// user cannot check.

/** Whether the viewer is on an Apple platform, where ⌘ is the app modifier. */
export function isApplePlatform(
  platform: string = typeof navigator === "undefined"
    ? ""
    : navigator.platform || navigator.userAgent
): boolean {
  return /Mac|iPhone|iPad|iPod/i.test(platform);
}

/** The label for a shortcut bound as meta+`key` and ctrl+`key` (the dashboard editor's ⌘S). */
export function modifierShortcutLabel(
  key: string,
  apple: boolean = isApplePlatform()
): string {
  return apple ? `⌘${key}` : `Ctrl+${key}`;
}

/** The label for the open-the-palette shortcut (bound as meta+K and ctrl+K). */
export function paletteShortcutLabel(
  apple: boolean = isApplePlatform()
): string {
  return apple ? "⌘K" : "Ctrl K";
}
